var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1C0.4 1 0 1.4 0 2C0 2.6 0.4 3 1 3H11V5H3C2.4 5 2 5.4 2 6V22C2 22.6 2.4 23 3 23H21C21.6 23 22 22.6 22 22V6C22 5.4 21.6 5 21 5H13V3H23C23.6 3 24 2.6 24 2C24 1.4 23.6 1 23 1ZM18 14C18 17.3 15.3 20 12 20C8.7 20 6 17.3 6 14C6 10.7 8.7 8 12 8C15.3 8 18 10.7 18 14Z",
    fill: "#063554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C11.7 15 11.5 14.9 11.3 14.7L9.3 12.7C8.9 12.3 8.9 11.7 9.3 11.3C9.7 10.9 10.3 10.9 10.7 11.3L12.7 13.3C13.1 13.7 13.1 14.3 12.7 14.7C12.5 14.9 12.3 15 12 15Z",
    fill: "#063554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassIcon);
export default __webpack_public_path__ + "static/media/mass-icon.994c9dcdef95c1e927c211a96e1ed567.svg";
export { ForwardRef as ReactComponent };